import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faAddressBook,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faArchive,
  faBuilding,
  faCaretDown,
  faChartBar,
  faCheck,
  faChevronDown,
  faChevronUp,
  faChild,
  faCircle,
  faCoffee,
  faComment,
  faEllipsisV,
  faFileAlt,
  faFileInvoice,
  faHome,
  faKey,
  faPencilAlt,
  faPlus,
  faQuestion,
  faSearch,
  faShoppingCart,
  faFileMedicalAlt,
  faSpinner,
  faTimes,
  faTrashAlt,
  faTruck,
  faUserEdit,
  faUser,
  faUsers,
  faEye,
  faChevronLeft,
  faDownload,
  faRedo,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';

Vue.component('FontAwesomeIcon', FontAwesomeIcon);

/* Include needed icons */
library.add(
  faAddressBook,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faArchive,
  faBuilding,
  faCaretDown,
  faChartBar,
  faCheck,
  faChevronDown,
  faChevronUp,
  faChild,
  faCircle,
  faCoffee,
  faComment,
  faEllipsisV,
  faFileAlt,
  faFileInvoice,
  faHome,
  faKey,
  faPencilAlt,
  faPlus,
  faQuestion,
  faSearch,
  faShoppingCart,
  faSpinner,
  faTimes,
  faTrashAlt,
  faTruck,
  faUserEdit,
  faUsers,
  faUser,
  faEye,
  faChevronLeft,
  faFileMedicalAlt,
  faDownload,
  faRedo,
  faInfoCircle,
);
